export default "__VITE_ASSET__IICF5c$r__"